import { Box, Divider, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { IPae } from '../../../services/api/action-plan/Pae';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface ISummaryPae {
    data: IPae
}

export const SummaryPae = ({data}: ISummaryPae) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box>
                <Typography><strong>Status da Sitação de Emergência</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data de atualização : </Typography>
                    <Typography>{formatDateWhitoutHour(data.situacaoEmergencia?.data_atualizacao)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Nível de emergência : </Typography>
                    <Typography>{data.situacaoEmergencia?.nive_emergencia}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box>
                <Typography><strong>Informações gerais do PAE</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data de emissão : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_emissao)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Empresa executora : </Typography>
                    <Typography>{data.empresa_executora}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Responsável técnico : </Typography>
                    <Typography>{data.responsavel_tecnico}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>ART (número) : </Typography>
                    <Typography>{data.art}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Órgão fiscalizador	 : </Typography>
                    <Typography>{data.orgao_fiscalizador}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box>
                <Typography><strong>Características do estudo de ruptura hipotética</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Fluxo Newtoniano : </Typography>
                    <Typography>{data.estudoRuptura?.fluxo_newtoniano}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Caracterização reológica : </Typography>
                    <Typography>{data.estudoRuptura?.caracterizacao_reologica}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Cenários simulado : </Typography>
                    <Typography>{data.estudoRuptura?.cenarios_simulados}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Modo de falha do cenário mais crítico : </Typography>
                    <Typography>{data.estudoRuptura?.falha_cenario_critico}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Volume mobilizado (m³) : </Typography>
                    <Typography>{data.estudoRuptura?.volume_mobilizado_m3}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Volume mobilizado (m³) : </Typography>
                    <Typography>{data.estudoRuptura?.volume_mobilizado_m3}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Volume mobilizado (%) : </Typography>
                    <Typography>{data.estudoRuptura?.volume_mobilizado}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>TR considerado no vale de jusante: </Typography>
                    <Typography>{data.estudoRuptura?.tr_jusante}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>TR considerado no cenário mais crítico	: </Typography>
                    <Typography>{data.estudoRuptura?.tr_critico}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Critério de parada da mancha: </Typography>
                    <Typography>{data.estudoRuptura?.parada_mancha}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '2px', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Critério de definição da ZAS: </Typography>
                    <Typography>{data.estudoRuptura?.definicao_zas}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '5px', overflowX: 'auto'}} width={'100%'}>
                <Typography><strong>Definição dos Níves de Emergência</strong></Typography>
                <Table component={Paper} sx={{borderRadius: '25px', borderColor: theme.palette.primary.contrastText, flex: 1}} variant='elevation'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nível</TableCell>
                            <TableCell>Definição</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.niveisEmergencia?.map((item, index) => 
                            <TableRow key={index}>
                                <TableCell>{item.nivel}</TableCell>
                                <TableCell>{item.definicao}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Box>
            {/* <Divider/>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                <Typography><strong>Definição dos Níves de Emergência</strong></Typography>
                <Table component={Paper} sx={{borderRadius: '25px', borderColor: theme.palette.primary.contrastText}} variant='elevation'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nível</TableCell>
                            <TableCell>Definição</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.niveisEmergencia.map((item, index) => 
                            <TableRow key={index}>
                                <TableCell>{item.nivel}</TableCell>
                                <TableCell>{item.definicao}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Box> */}
        </Box>
    );
};